// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".something[data-v-4d2318f8] {\n  background: rgba(255, 166, 0, 0.253);\n  box-sizing: border-box;\n  display: block;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: 99999;\n  visibility: hidden;\n  transition: linear background 1s;\n}\n.something.dragging[data-v-4d2318f8] {\n  display: block;\n  visibility: visible;\n  background: rgba(0, 60, 255, 0.253);\n}", ""]);
// Exports
module.exports = exports;
